import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const USER_API = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})

export class RewardsService {

  constructor(private http: HttpClient) { }

  getRewards(query): Observable<any> {
    return this.http.get(USER_API+"reward"+query);
  }

  getRewardDetails(id): Observable<any> {
    return this.http.get(USER_API+"reward/"+id);
  }

  addReward(rewarddata): Observable<any> { 
    return this.http.post(USER_API + 'reward', rewarddata );
  }

  updateReward(id, rewarddata) {
    return this.http.put(USER_API + 'reward/'+id, rewarddata);
  }

  getRewardList(query): Observable<any> {
    return this.http.get(USER_API+"reward"+query);
  }

  getRewardRequestList(id,query): Observable<any> {
    return this.http.get(USER_API+"reward/requestlist/"+id+query);
  }

  getRewardMessage(id): Observable<any> {
    return this.http.get(USER_API+"reward/requestlistedit/"+id);
  }

  updateRewardMessage(id, messageData): Observable<any> {
    return this.http.put(USER_API+"reward/updateRewardRequest/"+id, messageData);
  }

  getRewardLists(){
    return this.http.get<any[]>(USER_API+'/reward');
  }

  deleteReward(desId:string){
    return this.http.delete(USER_API + 'reward/'+desId);
  }  

}